import { ChangeDetectorRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormGroup } from '@angular/forms'
import _ from 'lodash'
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse'
import { StateService, FormulaireService } from '../../../../services'

@Component({
	selector: 'atyl-input-observe',
	templateUrl: './atyl-input-observe.component.html',
	styleUrls: ['./atyl-input-observe.component.scss']

})
export class AtylInputObserveComponent implements OnInit {

	@Input() name: any
	@Input() form: FormGroup

	@Output() observeChanged: EventEmitter<any> = new EventEmitter<any>(true);

	checked = false;
	groupeChamps: any[] = [];
	active = false;
	constructor(private readonly formulaireService: FormulaireService,
	private cdr: ChangeDetectorRef,
	private stateservice: StateService
	) {
	}

	ngOnInit(): void {
		const _options = {
			groupeName: this.name
		}

		this.disableInputs();
		this.formulaireService.getObserveFields(this.__keyfiy__(this.form.controls), _options).subscribe((res: JSONRpcResponse) => {
			const defaultObserveValue = 2
			if (res) {
				this.groupeChamps = res.result;
				let ids = [];
				res.result.map((field) => {
					ids.push(field.ID);
				})
				
				Object.keys(this.form.controls).forEach((value) => {
					let object = this.form.controls[value];
					if ( object["observe_champ"] == 2 && ids.includes(value) ) {
						this.active = true;
					}
				})

				if (this.active) {
					this.checked = true;
					this.tirggerLockObserve();
				} else {
					this.disableInputs();
				}
			}
		})
	}

	disableInputs() {
		this.checked = false;
		this.tirggerLockObserve()
	}

	trigger(event: any) {
		this.checked = event.checked
		this.tirggerLockObserve()
	}

	tirggerLockObserve() {
		const _options = {
			checked: this.checked
		}
		console.log("tirggerLockObserve",_options,this.groupeChamps)
		
		/*this.formulaireService.tirggerLockObserve(this.groupeChamps, _options).subscribe((res: JSONRpcResponse) => {
			this.observeChanged.emit(res.result)
			this.cdr.detectChanges()
		})*/
		this.groupeChamps.forEach((element: any) => {
            if (this.checked) {
                element.observe_value=2;
            } else
                element.observe_value=1;
            /* 
           console.log("groupeChamps",this.form.controls[element.ID]);
           
           if (this.form.controls[element.ID]) {
               if (this.checked)
                this.form.controls[element.ID].enable()
                else
                    this.form.controls[element.ID].enable()
                
            }*/
        }      
        )
      // console.log('groupeChamps',this.groupeChamps,this.form.controls)
       // this.form.controls
        
        this.active=this.checked;
        this.observeChanged.emit(this.groupeChamps)
        
       // this.stateservice.updateObservedField(this.groupeChamps);
        
        this.cdr.detectChanges()
        
		
		
	}



	private __keyfiy__(obj: any) {
		return Object.keys(obj)
	}

}
